export const NEGOTIATION_OVERVIEW_CHART_HEIGHT = 320

export const COLOR_NEGOTIATED = '#7B61FF'
export const COLOR_DECREASED = '#30A46C'
export const COLOR_NO_CHANGE = '#9E9E9E'
export const COLOR_INCREASED = '#E5484D'

export const COLOR_TILE_DECREASED = '#7B61FF'
export const COLOR_TILE_NO_CHANGE = '#9E9E9E'
export const COLOR_TILE_INCREASED = '#30A46C'
export const COLOR_TILE_AVG_DECREASE = '#0E9F9F'
export const COLOR_TILE_AVG_INCREASE = '#E5484D'

export const COLOR_HISTOGRAM_BAR = '#A79BF5'
export const COLOR_HISTOGRAM_LABEL = '#1F2937'

export const NEGOTIATION_OVERVIEW_EARLIEST_DATE = new Date(2024, 4, 1) // 1 May 2024

export const NEGOTIATION_OVERVIEW_RELIABLE_FROM_DATE = new Date(2026, 8, 1) // 1 September 2026

export const NEGOTIATION_OVERVIEW_INFO = [
  'Every job posted to the network within the selected period is assessed where the current ' +
    'allocation resulted from a winning Driver App bid. A job is considered negotiated if the ' +
    'winning bid price changed at least once between the original submission and allocation, ' +
    'including cases where the final price returned to the original value.',
  'The histogram shows the percentage difference between the original and final winning bid ' +
    'prices, while all monetary values are converted to GBP.',
  'These metrics apply only to jobs won through Driver App bids. Courier Exchange negotiations ' +
    'cannot be identified reliably because CX quote history is not retained, so jobs fulfilled ' +
    'through CX are excluded.',
].join('\n\n')

export const NEGOTIATION_OVERVIEW_FOOTNOTES = [
  'These figures apply only to jobs won through Driver App bids. Cancelled jobs, ' +
    'Quote Lost jobs, jobs fulfilled through Courier Exchange, and jobs without a ' +
    'winning bid are excluded.',
  'Each job is assigned to the period based on the date it was posted to the network ' +
    'and is counted once, even if it was allocated across multiple winning bids.',
  'Only the original and final winning bid values are used in the calculations; ' +
    'intermediate negotiation steps are ignored. All monetary values are converted ' +
    'to GBP.',
  'The figures are refreshed twice daily, so recent activity may take up to ' +
    'approximately 12 hours to appear.',
]

export const NEGOTIATED_JOBS_KPI_INFO = [
  'A job is considered negotiated if the price of its winning bid changed at least once ' +
    'between the initial submission and allocation, including cases where the final price ' +
    'returned to the original value.',
  'As a result, the negotiated-job total may be higher than the number of jobs represented ' +
    'in the histogram, since the histogram includes only bids with a non-zero final price ' +
    'change.',
  'The figures cover jobs within the selected period that were won through Driver App bids. ' +
    'Jobs fulfilled through Courier Exchange are excluded because CX negotiation history is ' +
    'not available.',
].join('\n\n')

export const PRICE_DELTA_HISTOGRAM_INFO = [
  'Shows the distribution of price changes between the original bid price and the final ' +
    'negotiated price for each winning bid, calculated as:',
  '(Final − Original) ÷ Original × 100',
  'Negative values indicate that the final price was negotiated down, while positive values ' +
    'indicate that it was negotiated up.',
  'Only negotiated winning bids with a non-zero final price change are included in the ' +
    'histogram. Each winning bid contributes a single observation based on its original and ' +
    'final values, regardless of how many negotiation steps occurred in between.',
  'Negotiations that ultimately returned to the original price are still included in the ' +
    'negotiated-jobs KPI, but are excluded from the histogram.',
].join('\n\n')

export const DECREASED_INFO = [
  'Shows the number of negotiated jobs where the final winning bid price was lower than the ' +
    'original bid price.',
  'The percentage represents the share of these jobs out of all negotiated jobs in the ' +
    'selected period.',
].join('\n\n')

export const NO_CHANGE_INFO = [
  'Shows the number of negotiated jobs where the final winning bid price returned to the ' +
    'original bid value.',
  'These jobs are included in the negotiated-jobs KPI, but excluded from the histogram ' +
    'because their final price change is 0%.',
].join('\n\n')

export const INCREASED_INFO = [
  'Shows the number of negotiated jobs where the final winning bid price was higher than ' +
    'the original bid price.',
  'The percentage represents the share of these jobs out of all negotiated jobs in the ' +
    'selected period.',
].join('\n\n')

export const AVG_DECREASE_INFO = [
  'Shows the average percentage decrease across all negotiated jobs where the final winning ' +
    'bid price was lower than the original bid price.',
  "The average is calculated using each job's original and final winning bid prices.",
].join('\n\n')

export const AVG_INCREASE_INFO = [
  'Shows the average percentage increase across all negotiated jobs where the final winning ' +
    'bid price was higher than the original bid price.',
  "The average is calculated using each job's original and final winning bid prices.",
].join('\n\n')

export const NEGOTIATED_DOWN_INFO = [
  'Shows the total amount saved through negotiation across all jobs where the final winning ' +
    'bid price was lower than the original bid price.',
  'It is calculated as the sum of Original Winning Bid Price − Final Winning Bid Price, ' +
    'with all values converted to GBP.',
].join('\n\n')

export const NEGOTIATED_UP_INFO = [
  'Shows the total amount added through negotiation across all jobs where the final winning ' +
    'bid price was higher than the original bid price.',
  'It is calculated as the sum of Final Winning Bid Price − Original Winning Bid Price, ' +
    'with all values converted to GBP.',
].join('\n\n')
